import React from 'react';
import { Button, Popconfirm, Space, Switch, Table, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const buildColumns = ({ currentUserId, onToggleAdmin, onImpersonate, onEdit, onDelete }) => [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: (a, b) => a.id - b.id },
    { title: 'Username', dataIndex: 'username', key: 'username', sorter: (a, b) => a.username.localeCompare(b.username) },
    { title: 'Email', dataIndex: 'email', key: 'email', sorter: (a, b) => (a.email || '').localeCompare(b.email || '') },
    { title: 'Verified', dataIndex: 'is_verified', key: 'is_verified', render: (v) => v ? 'Verified' : 'Not verified' },
    {
        title: 'Is Admin',
        dataIndex: 'is_admin',
        key: 'is_admin',
        render: (isAdmin, record) => (
            <Switch checked={isAdmin} onChange={() => onToggleAdmin(record)} />
        ),
    },
    {
        title: 'Actions',
        key: 'actions',
        render: (text, record) => (
            <Space size="middle">
                <Tooltip title={record.is_admin ? 'Cannot impersonate admin users' : record.id === currentUserId ? 'Cannot impersonate yourself' : 'Impersonate this user'}>
                    <Button
                        onClick={() => onImpersonate(record.id, record.username)}
                        disabled={record.is_admin || record.id === currentUserId}
                    >
                        Impersonate
                    </Button>
                </Tooltip>
                <Tooltip title="Edit">
                    <Button icon={<EditOutlined />} onClick={() => onEdit(record)} />
                </Tooltip>
                <Popconfirm
                    title="Are you sure you want to delete this user?"
                    onConfirm={() => onDelete(record.id)}
                    okText="Yes"
                    cancelText="No"
                >
                    <Tooltip title="Delete">
                        <Button icon={<DeleteOutlined />} danger />
                    </Tooltip>
                </Popconfirm>
            </Space>
        ),
    },
];

export default function UsersTable({ users, loading, currentUserId, onToggleAdmin, onImpersonate, onEdit, onDelete }) {
    const columns = buildColumns({ currentUserId, onToggleAdmin, onImpersonate, onEdit, onDelete });

    return (
        <Table
            columns={columns}
            dataSource={users}
            rowKey="id"
            loading={loading}
            pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users`,
                size: 'small'
            }}
            scroll={{ x: 800 }}
            size="small"
            bordered={false}
        />
    );
}
